import { useTranslation } from 'react-i18next';
import { Button } from '@components/ui/Button/Button';
import { Modal } from '@components/ui/Modal/Modal';
import styles from './AlertsHubTab.module.css';

export interface IConfirmReachDialogProps {
  /** How many recipients the change applies to. */
  reach: number;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Asked before a Hub channel or frequency change on a row with recipients:
 * Trusstor's engine writes it over each recipient's own choice, so the page
 * says so plainly before it does.
 */
export function ConfirmReachDialog({ reach, onConfirm, onCancel }: IConfirmReachDialogProps) {
  const { t } = useTranslation();
  return (
    <Modal
      open
      size="sm"
      onClose={onCancel}
      title={t('alertSettings.hub.confirm.title')}
      description={t('alertSettings.hub.confirm.body', { count: reach })}
      footer={
        <>
          <span className={styles.spacer} />
          <Button variant="secondary" size="md" onClick={onCancel}>
            {t('common.cancel')}
          </Button>
          <Button variant="primary" size="md" onClick={onConfirm}>
            {t('alertSettings.hub.confirm.yes')}
          </Button>
        </>
      }
    />
  );
}
